import { render, staticRenderFns } from "./videomedia-add-or-update.vue?vue&type=template&id=05f74ab0&"
import script from "./videomedia-add-or-update.vue?vue&type=script&lang=js&"
export * from "./videomedia-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports